import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const SepticService = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my septic service business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps septic service businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for septic service businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most septic service businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my septic service business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like septic service. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Septic Service - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Septic Service CRM", url: "/industries/septic-service" }
  ];

  const industryData = {
    name: 'Septic Tank Service',
    title: 'Capture Emergency Calls & Build Recurring Maintenance Revenue',
    subtitle: 'Never miss urgent septic emergencies, automate pumping reminders, and build predictable service routes',
    icon: '🚛',
    challenges: [
      'Emergency calls come at all hours',
      'Customers forget about regular pumping',
      'Hard to plan efficient service routes',
      'One-time emergencies don\'t return',
      'Seasonal demand fluctuations'
    ],
    solutions: [
      'Emergency call routing 24/7',
      'Pumping interval tracking and reminders',
      'Route optimization system',
      'Maintenance plan automation',
      'Year-round service diversification'
    ],
    features: [
      'Customer CRM with tank details',
      'Emergency call capture',
      'Pumping schedule automation',
      'Route planning optimization',
      'Service history tracking',
      'Inspection documentation',
      'Real estate transaction coordination',
      'Review automation'
    ],
    results: [
      '90% emergency to maintenance conversion',
      'Optimize routes by 45%',
      'Never miss a scheduled pumping',
      '£6.2K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Septic Service UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for septic service businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for septic service UK, septic service business software, septic service customer management, septic service lead generation UK"
        url="/industries/septic-service"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default SepticService;